import {cn} from '@bem-react/classname';

export const cnAnswerOption = cn('AnswerOption');
